import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class KaCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (KaCalculationMethodModel._instance == null) KaCalculationMethodModel._instance = new KaCalculationMethodModel(authManager);
        return KaCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/ka-calculation-methods', 'face-pressures/ka-calculation-methods/codelist');

        this.entityName = 'face-pressures.KaCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Ka Method';
        this.setLabel = 'Ka Methods';

        this.browser = {
            name: 'default-face-pressures-kacalculationmethod-browser',
            moduleName: 'default-face-pressures-kacalculationmethod-browser',
            moduleTitle: 'Ka Methods',
            moduleStateSlotName: 'default-face-pressures-kacalculationmethod-browser',
        };

        this.editor = {
            name: 'default-face-pressures-kacalculationmethod-editor',
            moduleName: 'default-face-pressures-kacalculationmethod-editor',
            moduleTitle: 'Ka Method',
            moduleStateSlotName: 'default-face-pressures-kacalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'isDefault',
                type: 'bool',
                persistent: true,
                label: 'Is Default',
            },
        ];

    }

}
